<template>
    <div>
        <div v-if="fetchedProgram != null && !loading" class="profile__container--content__membershipProgram--info-page text-center" :class="$vuetify.breakpoint.smAndDown ? 'py-5' : ''">
            <div class="profile__container--content__membershipProgram--info-page__title">
                {{program.programName}} <br>
            </div>
            <div class="d-flex justify-center my-14">
                <animated-icon size="174" icon="fxt-user-group" iconColor="primary" backgroundColor="var(--v-primary-opacity-12)"></animated-icon>
            </div>
            <div class="profile__container--content__membershipProgram--info-page__description">
                <p><span v-html="program.joinDescription"></span></p>
            </div>
            
            <div class="d-flex flex-column justify-center align-center">
                <v-btn
                    class="font-weight-bold secondary-font text-none my-2"
                    color="primary"
                    rounded
                    elevation="0"
                    :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width:50%'"
                    @click="joinProgram()"
                >
                    Bli medlem
                </v-btn>
                <v-btn
                    class="font-weight-bold secondary-font text-none my-2"
                    color="primary"
                    rounded
                    outlined
                    :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width:50%'"
                    @click="switchComponent()"
                >
                    Vilkår for bruk
                </v-btn>
            </div>
            <v-overlay :value="loading" color="white" absolute style="height: 600px">
                <v-progress-circular
                    color="var(--v-primary-base)"
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </div>
        <div v-else>
            <v-overlay :value="loading" color="white" absolute style="height: 600px">
                <v-progress-circular
                    color="var(--v-primary-base)"
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </div>
    </div>
</template>

<script>
import { TheConsentToggle } from '../../../../Common/CommonComponents'
import AnimatedIcon from '../../../../Common/CommonComponents/AnimatedIcon.vue'
import ProfileSvc from '../../../../../services/profile-svc';
let profileSvc = null;
export default {
    components: { AnimatedIcon, TheConsentToggle },
    props: {
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
        programId: {
            required: false,
            default: 0,
            type: Number
        },
        siteId: {
            required: false,
            default: 0,
            type: Number
        }
    },
    data: () => ({
        loading: false,
        fetchedProgram: null
    }),

    computed: {
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        program() {
            return this.fetchedProgram.program
        }
    },
    methods: {
        switchComponent() {
            if (this.layout == 'chain') {
                this.$router.replace({query: {title: 'vilkaar-for-bruk', id: this.program.customerProgramId, siteId: this.$route.query.siteId ? this.$route.query.siteId : this.siteId}, params: {program: this.program}})
            } else {
                this.$router.push({name: 'Vilkår for bruk', params: {id: this.program.customerProgramId, program: this.program}, query: {siteId: this.program.customer.siteId}})
            }
        },
        getCustomerCategoryId() {
            return this.program.customerCategories.length 
            ? this.program.customerCategories.find(x => x.customerProgramId == this.program.customerProgramId).customerCategoryId 
            : this.program.customerCategories[0].customerCategoryId 
            || null
        },
        async joinProgram() {
            this.loading = true
            var result = await profileSvc.AddOrRemoveCustomerProgram(this.bookingApi, {
                registerCustomerInCustomerProgram: true,
                customerCategoryId: this.getCustomerCategoryId() != null ? this.getCustomerCategoryId() : this.program.defaultCustomerCategoryId,
                chainId: this.program.chainId,
                siteId: 0, //This field isn't being used backend, so it's set to a static 0.
            })
            if (result) {
                if (this.layout == 'portal') {
                    this.$router.push({name: 'Info fordelsprogram', params: {id: this.program.customerProgramId, program: this.program}, query: {siteId: this.program.customer.siteId}}) 
                } else {
                    this.$emit('refresh')
                }
            }
            this.loading = false
        }
    },
    async created() {
        this.loading = true
        profileSvc = await ProfileSvc(this.$axios);
        this.fetchedProgram = await profileSvc.GetCustomerProgramById(this.bookingApi, this.layout == 'portal' ? this.$route.params.id : this.programId, this.$route.query.siteId ? this.$route.query.siteId : this.siteId)
        if (this.program && this.program.isMember) {
            if (this.layout == 'portal') {
                    this.$router.push({name: 'Info fordelsprogram', params: {id: this.program.customerProgramId, program: this.program}, query: {siteId: this.program.customer.siteId}}) 
                } else {
                    this.$emit('refresh')
                }
        }
        this.loading = false
	},
    beforeDestroy() {
		profileSvc = null
	}
}
</script>